/**
 * Date 型の表記を変更し、画面表示用の文字列を取得する
 * @param date Date型の日付
 * @param format フォーマット指定（YYYY:年, MM:月, DD:日, AA:曜日）
 * @returns 書式変換後の文字列
 */
const formatDate = (format: string, date?: Date, ) => {
    if (!date) {
        return;
    }

    const week = ["日", "月", "火", "水", "木", "金", "土"];

    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const dayOfWeek = week[date.getDay()];

    format = format.replace(/YYYY/gi, year.toString());
    format = format.replace(/MM/gi, month.toString());
    format = format.replace(/DD/gi, day.toString());
    format = format.replace(/AA/gi, dayOfWeek);
    return format;
}

export default formatDate;
